module.exports = __webpack_public_path__ + "img/amalan-x-cek-aja.99096f12.png";